import type {
    ClientProjectResourceCurrencyEnum,
    ProjectClientAction,
    ProjectStatus,
    ClientProjectType,
    SortOrder,
    VerticalType,
    OpportunityType,
    RenewalStatus,
} from '@api';

// - DataTable formatted data

export type ColumnSortOrder = 'ASC' | 'DESC';
export interface ColumnSortType<T extends Record<string, any>> {
    key: keyof T;
    order: ColumnSortOrder;
}

export type DataTableColumn = Extract<
    keyof FormattedClientProjectResource,
    | 'title'
    | 'projectOwner'
    | 'freelancer'
    | 'freelancerPrice'
    | 'total'
    | 'company'
    | 'organization'
    | 'startDate'
    | 'endDate'
    | 'sortDateForClient'
    | 'purchaseOrder'
    | 'status'
    | 'actions'
    | 'verticalType'
    | 'opportunityType'
    | 'renewalStatus'
>;
export type DataTableColumnArray = Array<keyof Pick<FormattedClientProjectResource, DataTableColumn>>;

export interface FormattedClientProjectResource {
    id: string;
    lotId?: string;
    title: string;
    startDate?: string;
    endDate?: string;
    sortDateForClient?: string;
    projectOwner: string;
    company: string;
    companyId: string;
    organization?: string;
    total: number | undefined;
    purchaseOrder?: string;
    purchaseOrderNumber?: string;
    purchaseOrderBudget?: number;
    purchaseOrderComment?: string;
    purchaseOrderMandatory: boolean;
    currency: ClientProjectResourceCurrencyEnum;
    status: ProjectStatus;
    freelancer: string;
    actions: ProjectClientAction[];
    type: ClientProjectType;
    freelancerAvatar?: string;
    freelancerPrice: string;
    paymentLimitDate?: Date;
    expensePaymentIds?: string[];
    expenseBatchIds?: string[];
    companyManager?: string;
    finOpsManager?: string;
    plannedExpirationDate?: Date;
    verticalType?: VerticalType;
    opportunityType?: OpportunityType;
    renewalStatus?: RenewalStatus;
    renewalTargetCorrelationId?: string;
    correlationId?: string;
}

export enum ProjectCurrencyTypeMapper {
    EUR = '€',
    GBP = '£',
    USD = '$',
}

export interface Action {
    header: string;
    id: string;
    dataField: string;
    sortOrder: string | null;
    selected: boolean;
    title: string;
}

export type DataTableSize = 'small' | 'large' | 'medium';

export type SortableHeaders = DataTableColumn; // All the column are sortable for now

export interface SortingOptions {
    sortBy?: SortableHeaders;
    sortOrder?: SortOrder;
}

export enum PaymentRedirectionSuccessTypes {
    Card = 'success-card',
    WebCard = 'success-webcard',
    Transfer = 'success-transfer',
}
